import { uiPics } from "../../assets/projectsUiPics"

export const PorjectsData: ProjectsDataType[] = [
  {
    id: 1,
    name: "CloudStore",
    imgUrls: uiPics.CloudStore,
    description:
      " A modern and secure cloud storage application, designed for seamless file management and collaboration. ",
    techlonogies:
      "Next.js, Mongoose, Cloudinary, Nodemailer, ShadCN, Tailwind CSS.",
    liveUrls: "https://cloud-store-smoky.vercel.app/",
    codeUrls: "https://github.com/ajaysinhaorigin/cloudstore",
  },
  {
    id: 2,
    name: "Property-Pulse",
    imgUrls: uiPics.Propertypulse,
    description:
      " A web application designed to assist users in finding their next rental property.  ",
    techlonogies: "Next.js, NextAuth.js, Mongoose, Typescript, Tailwind CSS.",
    liveUrls: "https://property-pulse-swart-eta.vercel.app/",
    codeUrls: "https://github.com/ajaysinhaorigin/property-pulse",
  },
  {
    id: 3,
    name: "Sketchboard",
    imgUrls: uiPics.Sketchboard,
    description:
      "An online drawing tool powered by Next.js, the Canvas API, and Redux for state management.",
    techlonogies:
      "Next.js, React.js, Typescript, Tailwind CSS, Redux-Toolkit, Canvas API.",
    liveUrls: "https://sketchboard-eta.vercel.app/",
    codeUrls: "https://github.com/ajaysinhaorigin/sketchboard",
  },
  {
    id: 4,
    name: "Streamify",
    imgUrls: uiPics.SteamifyImage,
    description:
      "A highly scalable and efficient video streaming platform utilizing YouTubes API.",
    techlonogies:
      "ReactJs, Typescript, Tailwind CSS, Redux-Toolkit, Youtube REST API",
    liveUrls: "https://youtube-origin.vercel.app/",
    codeUrls: "https://github.com/ajaysinhaorigin/streamify",
  },
  {
    id: 5,
    name: "Github-Finder",
    imgUrls: uiPics.GithubFinder,
    description:
      "Github-Finder is a platform where you can search github users and find all the key details of there account",
    techlonogies:
      "ReactJs, Typescript, Tailwind CSS,Redux-Toolkit, Github REST API",
    liveUrls: "https://ajaysinhaorigin.github.io/github-finder/",
    codeUrls: "https://github.com/ajaysinhaorigin/github-finder",
  },
  // {
  //   id: 6,
  //   name: "House-Marketplace",
  //   imgUrls: uiPics.HouseMarketplace,
  //   description:
  //     "Website that helps you sale your house and put it on rent.Create an account and start saling your house.",
  //   techlonogies: "ReactJs, Javascript, CSS,Firebase",
  //   liveUrls: "https://house-marketplace-psi-mocha.vercel.app/",
  //   codeUrls: "https://github.com/ajaysinhaorigin/house-marketplace",
  // },
]
